// utils/autoScale.ts
import { SCALE_RANGES } from "@/utils/gridScale";

export const getAutoScaleRange = (nodes: any[]) => {
  if (!nodes || nodes.length === 0) {
    return SCALE_RANGES[0].max;
  }

  let max = 0;

  for (const n of nodes) {
    const x = Math.abs(n.x ?? 0);
    const y = Math.abs(n.y ?? 0);
    const z = Math.abs(n.z ?? 0);

    max = Math.max(max, x, y, z);
  }

  // Find closest scale range
  for (const range of SCALE_RANGES) {
    if (max <= range.max) {
      return range.max;
    }
  }

  return SCALE_RANGES[SCALE_RANGES.length - 1].max;
};
